import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';

import { cn } from '../lib/utils';

/**
 * Señal de que el contenido sigue más allá del borde visible.
 *
 * Es presentacional puro: recibe dos booleanos y no sabe qué es un patrón ni
 * una fila (Artículo II.4). Quien lo monta calcula la visibilidad con la
 * geometría del lienzo.
 *
 * Va superpuesto en el DOM y no dibujado dentro del `<canvas>` para poder
 * declararse transparente al puntero: las celdas que quedan debajo tienen que
 * seguir pintándose con toque y con arrastre.
 */
export interface ScrollHintProps {
  readonly showTop: boolean;
  readonly showBottom: boolean;
  readonly labelTop: string;
  readonly labelBottom: string;
  readonly className?: string;
}

/** El degradado sitúa la señal; la flecha la explica sin recurrir al color. */
const edge =
  'pointer-events-none absolute inset-x-0 flex h-10 items-center justify-center text-foreground/70';

export function ScrollHint({
  showTop,
  showBottom,
  labelTop,
  labelBottom,
  className,
}: ScrollHintProps) {
  return (
    <>
      {showTop && (
        <div
          data-slot="scroll-hint"
          role="presentation"
          aria-label={labelTop}
          className={cn(
            edge,
            'from-background/90 top-0 bg-gradient-to-b to-transparent',
            className,
          )}
        >
          <ChevronUpIcon className="size-5" aria-hidden="true" />
        </div>
      )}

      {showBottom && (
        <div
          data-slot="scroll-hint"
          role="presentation"
          aria-label={labelBottom}
          className={cn(
            edge,
            'from-background/90 bottom-0 bg-gradient-to-t to-transparent',
            className,
          )}
        >
          <ChevronDownIcon className="size-5" aria-hidden="true" />
        </div>
      )}
    </>
  );
}
